import React from 'react';
import PageContainer from '../PageContainer';
import './two.scss';
import video from '../videos/Two countries.mp4';
import { MediaQueryContext } from '../MediaQueryContext';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuoteRight } from '@fortawesome/free-solid-svg-icons';
import PageTitle from '../PageTitle';
import { greyText } from '../styles';

class TwoCountries extends React.Component {
  static contextType = MediaQueryContext;

  constructor() {
    super();
    this.text = React.createRef();
    this.heightRef = React.createRef();
  }
  onPlay(e) {
    this.interval = setInterval(() => {
      let rect = this.heightRef.current?.getBoundingClientRect();
      let textRect = this.text.current?.getBoundingClientRect();
      if (!rect || !textRect) return;

      let percentPlayed = (e.target.currentTime / e.target.duration)
      this.text.current.scrollTo({ left: 0, top: (rect.height * percentPlayed) - (textRect.height / 2), behavior: 'smooth' });
      [...this.heightRef.current.children].forEach((node, index) => {

        let nodeRect = node.getBoundingClientRect();

        let center = textRect.height / 2;
        let top = nodeRect.top - textRect.top + 50;

        if (top < center - 50) {
          node.style.opacity = Math.pow(top / center, 2);
        } else if (top > center + 50) {
          node.style.opacity = Math.pow(center / top, 2);
        } else {
          node.style.opacity = 1;
        }
      })
    }, 100)

  }

  onPause() {
    clearInterval(this.interval);
  }
  componendWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  render() {
    return (
      <PageContainer {...this.props} className="two-countries" >

        <div className="two-countries-container">
          <div className="page-subtitle">
            <i>Exploring multiple identities through poetry and Animation.</i>
            <br />
            <i style={{ color: greyText, marginBottom: '2rem' }}>Utforsk mangfoldige identiteter gjennom poesi og animasjon</i>
          </div>
          {!this.context.isDesktop &&
            <Link to="/full-poem" className="button secondary">
              <FontAwesomeIcon color="#DE513E" icon={faQuoteRight} />
              <span>READ FULL POEM</span>
            </Link>
          }

          {!this.context.isDesktop &&
            <h4 className="poem-credit">
              <span>Based on the poem</span>
              <span> "Two Countries"</span>
              <span>by NAOMI SHIHAB NYE</span>
            </h4>
          }
          <div className="left">
            {!this.context.isMobile &&

              <div ref={this.text} className="two-text">
                <div ref={this.heightRef} style={{ position: 'relative' }} >

                  <span>Skin remembers how long the years grow</span>
                  <span>when skin is not touched, a gray tunnel</span>
                  <span>of singleness, feather lost from the tail</span>
                  <span>of a bird, swirling onto a step,</span>
                  <span>swept away by someone who never saw</span>
                  <span>it was a feather. Skin ate, walked,</span>
                  <span>slept by itself, knew how to raise a</span>
                  <span>see-you-later hand. But skin felt</span>
                  <span>it was never seen, never known as</span>
                  <span>a land on the map, nose like a city,</span>
                  <span>hip like a city, gleaming dome of the mosque</span>
                  <span>and the hundred corridors of cinnamon and rope.</span>
                  <span>Skin had hope, that’s what skin does.</span>
                  <span>Heals over the scarred place, makes a road.</span>
                  <span>Love means you breathe in two countries.</span>
                  <span>And skin remembers--silk, spiny grass,</span>
                  <span>deep in the pocket that is skin’s secret own.</span>
                  <span>Even now, when skin is not alone,</span>
                  <span>it remembers being alone and thanks something larger</span>
                  <span>that there are travelers, that people go places</span>
                  <span>larger than themselves.</span>
                  <span>Naomi Shihab Nye</span>
                </div>

              </div>}

          </div>
          <div className="right">
            <video width="320" height="240" controls onPlay={this.onPlay.bind(this)} onPause={this.onPause.bind(this)} >
              <source src={video} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
          </div>

          {!this.context.isMobile && <h4>Poem by Naomi Shihab Nye</h4>}
          <h4 className="animation-credit">Animation by Imad Alwahibi</h4>

        </div>
        <PageTitle>TWO COUNTRIES</PageTitle>

      </PageContainer >
    );
  }
}

export default TwoCountries;
